import React from "react";
import {Box, List, ListItem, ListItemButton, ListItemText, Paper, Stack, Typography,} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ListWithSecondaryText = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                    List Item with Secondary Text
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    background
                    title={"list item with secondary text"}
                    value={"                <List>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemText primary=\"Inbox\" secondary={\"check inbox\"} />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton>\n" +
                        "                                <ListItemText primary=\"Drafts\" secondary={\"check draft\"} />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                    </List>"}
                >
                    <Paper p={3} elevation={0} sx={{width: 250}}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary="Inbox" secondary={"check inbox"} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary="Drafts" secondary={"check draft"} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    </Paper>
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default ListWithSecondaryText;
